import { useMemo } from 'react'

import { FormConfig } from '@workwave-tidal/core/form'

import { TrackingPageForm } from './TrackingPageForm'
import { Footer } from './components/Footer'

import { form } from './formState'

import { useTexts } from '../hooks/useTexts'
import { useOnSubmit } from './hooks/useOnSubmit'

import type { TrackingAppFormProps as Props } from '../types'
import { TrackingPageFormValues } from './typings'

export function TrackingPageFormProvider(props: Props) {
  const { formValues, updateTrackingAppData, onCancel } = props

  const texts = useTexts()

  const onSubmit = useOnSubmit(updateTrackingAppData, onCancel)

  const config = useMemo<FormConfig<TrackingPageFormValues>>(
    () => ({
      id: 'trackingPage-form',
      initialValues: formValues,
    }),
    [formValues],
  )

  return (
    <form.Form
      testId="trackingPage-form"
      title={texts.headerTitle}
      subtitle={texts.headerDescription}
      footer={<Footer />}
      onSubmit={onSubmit}
      config={config}
      requireTransaction={false}
      stopEditingOnUnmount
      applyPendingFitMapOnMount={false}
    >
      <TrackingPageForm />
    </form.Form>
  )
}
